 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781426852985_COV from '@/components/9781426852985_cov'
 import A781426852985_TIT from '@/components/9781426852985_tit'
 import A781426852985_FM01 from '@/components/9781426852985_fm01'
 import A781426852985_FM02 from '@/components/9781426852985_fm02'
 import A781426852985_DED from '@/components/9781426852985_ded'
 import A781426852985_CON01 from '@/components/9781426852985_con01'
 import A781426852985_CH01 from '@/components/9781426852985_ch01'
 import A781426852985_CH02 from '@/components/9781426852985_ch02'
 import A781426852985_CH03 from '@/components/9781426852985_ch03'
 import A781426852985_BK02 from '@/components/9781426852985_bk02'
 import A781426852985_BKK from '@/components/9781426852985_bkk'
 import A781426852985_ABS from '@/components/9781426852985_abs'
 import A781426852985_COP from '@/components/9781426852985_cop'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781426852985_con01",
 			"name" : "9781426852985_con01",
 			"component" : A781426852985_CON01
 		},
 		{
 			"path" : "/9781426852985_ch01",
 			"name" : "9781426852985_ch01",
 			"component" : A781426852985_CH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js